// Parse redirects and build hierarchical tree structure
export const parseRedirects = (redirects) => {
  const tree = {};
  
  redirects.forEach((redirect) => {
    const { source } = redirect;
    
    // Skip non-path sources (like domain redirects)
    if (!source.startsWith('/')) {
      return;
    }
    
    // Remove leading slash and split into segments
    const segments = source.substring(1).split('/').filter(segment => segment.length > 0);
    
    // Build tree structure
    let currentLevel = tree;
    let currentPath = '';
    
    segments.forEach((segment, index) => {
      currentPath += '/' + segment;
      
      if (!currentLevel[segment]) {
        currentLevel[segment] = {
          name: segment,
          path: currentPath,
          level: index + 1,
          count: 0,
          children: {},
          redirects: []
        };
      }
      
      // Add redirect to this level
      currentLevel[segment].redirects.push(redirect);
      currentLevel[segment].count = currentLevel[segment].redirects.length;
      
      currentLevel = currentLevel[segment].children;
    });
  });
  
  // Convert to array format and sort by count (descending), then lexicographically
  const convertToArray = (treeLevel) => {
    return Object.values(treeLevel)
      .map(node => ({
        ...node,
        children: convertToArray(node.children)
      }))
      .sort((a, b) => {
        // First sort by count (descending)
        if (b.count !== a.count) {
          return b.count - a.count;
        }
        // Then sort lexicographically (ascending)
        return a.name.localeCompare(b.name);
      });
  };
  
  return convertToArray(tree);
};

// Get total count for a tree node (including children)
export const getTotalCount = (node) => {
  let total = node.count;
  if (node.children && node.children.length > 0) {
    total += node.children.reduce((sum, child) => sum + getTotalCount(child), 0);
  }
  return total;
};

// Get depth of tree
export const getTreeDepth = (nodes) => {
  if (!nodes || nodes.length === 0) return 0;
  return 1 + Math.max(...nodes.map(node => getTreeDepth(node.children)));
}; 